module.exports = __webpack_public_path__ + "img/icon-hearth-inactive.3b48706d.png";